import type { IconProps } from './types';

export const IconAlertCircle = ({ width, height, color = 'white', className }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 500 500'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill={color}
        d='M250,500c-66.8,0-129.6-26-176.8-73.2S0,316.8,0,250S26,120.4,73.2,73.2S183.2,0,250,0s129.6,26,176.8,73.2
        S500,183.2,500,250s-26,129.6-73.2,176.8S316.8,500,250,500z M250,41.7C135.1,41.7,41.7,135.1,41.7,250S135.2,458.3,250,458.3
        c114.9,0,208.3-93.5,208.3-208.3C458.3,135.1,364.9,41.7,250,41.7z'
      />
      <path
        d='M250 140V300'
        stroke={color}
        strokeWidth='42'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M250 370V370.5'
        stroke={color}
        strokeWidth='42'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
